export enum TagActiontypes {
  SET_MATTER_TAG_MODAL_DATA = "@@tags/SET_MATTER_TAG_MODAL_DATA",
  RESET_MATTER_TAG_MODAL_DATA = "@@tags/RESET_MATTER_TAG_MODAL_DATA",
}
